



































import { Vue, Component, Prop } from "@/shared/vuepack";
import { Permission } from "@/shared/types";
import PartnerReconReport from "@/employer/components/reports/PartnerReconReport.vue";
import PartnerBillingReport from "@/employer/components/reports/PartnerBillingReport.vue";
import EmployerBillingReport from "@/employer/components/reports/EmployerBillingReport.vue";
import { usePayrollReportStore } from "@/employer/store/payrollReport";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";

interface ReportItem {
  reportType: string;
  reportLabel: string;
}

@Component({
  components: {
    PartnerReconReport,
    PartnerBillingReport,
    EmployerBillingReport
  }
})

export default class Reports extends Vue {
  payrollReportStore = usePayrollReportStore();
  rolePermissionsStore = useRolePermissionsStore();

  @Prop() employerId: number;
  @Prop() partnerId: number;

  monthlyBillingReport: ReportItem = {
      reportType: "DETAIL",
      reportLabel: "Monthly Billing Report"
    };

  reconReport: ReportItem = {
    reportType: "RECON",
    reportLabel: "Employee-Paid Fees Reconciliation Report"
  };

  employeeAccountReport: ReportItem = {
    reportType: "EMPLOYEE_ACCOUNT",
    reportLabel: "Employee Account Report"
  };

  selectedReport = "";

  get reports () {
    const reports: { [key: string]: ReportItem} = {};

    if (this.rolePermissionsStore.userHasPermission(Permission.BillingReportRead)) {
      reports.monthlyBillingReport = this.monthlyBillingReport;
    }

    if (this.partnerId) {
      reports.reconReport = this.reconReport;
    }

    if (this.displayEmployeeAccountReport) {
      reports.employeeAccountReport = this.employeeAccountReport;
    }

    return reports;
  }

  get displayEmployeeAccountReport (): boolean {
    return this.rolePermissionsStore.userHasPermission(Permission.HsaInfoReportRead) && !!this.employerId;
  }

  get selectedReportOrNull () { return this.reports[this.selectedReport]; }
  get hasSelectedReport () { return !!this.selectedReportOrNull; }
  get reportType () { return this.hasSelectedReport ? this.selectedReportOrNull.reportType : null; }
  get didSelectReconReport () {
    return this.hasSelectedReport && this.selectedReportOrNull.reportType === "RECON";
  }
  get didSelectDetailReport () {
    return this.hasSelectedReport && this.selectedReportOrNull.reportType === "DETAIL";
  }
  get didSelectEmployeeBankInfoReport () {
    return this.hasSelectedReport && this.selectedReportOrNull.reportType === "EMPLOYEE_ACCOUNT";
  }

  downloadEmployeeAccountReport () {
    this.payrollReportStore.generateEmployeeBankInfoReport();
  }
}
